/*
 * Copyright (c) Hilo 2020.
 * Author: fharold
 *
 * hilo-oauth-manager
 * FormInput.tsx
 */

import {ButtonProps} from "./ButtonProps";
import Colors from "../../../model/enumerations/Colors";
import Translation from "../../../../services/translation/Translation";

export type ButtonEvent = (key?: string) => void;

export default function saveButton(): ButtonProps {
    return {
        color: Colors.blue,
        disabled: false,
        fullwidth: false,
        icon: undefined,
        key: "save_button",

        labelAccessor(t: Translation): string {
            return t.save;
        },

        loading: false,

        onClick(key: string | undefined): void {
        },

        outline: false
    };

}